<template>
    <div class="h-48 flex relative mx-auto w-full" :class="{ 'blue-bg':!dark, 'bg-white':dark}">
      <div class="md:ml-auto lg:ml-auto xl:ml-auto md:mr-0 lg:mr-0 xl:mr-0 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full flex flow-root justify-center">
        <a class="xl:text-3xl lg:text-xl text-sm block text-center" :class="{'text-white':!dark, 'text-black':dark}" href="tel:0785014638">0785014638</a>
        <a class="xl:text-xl lg:text-xl text-sm block text-center" :class="{'text-white':!dark, 'text-black':dark}" href="mailto:hello@freedfromdesigner.com">hello@freedfromdesigner.com</a>
      </div>
    </div>
</template>
<script>
export default {
  name: 'Contact',
  props: {
    dark: {
      type: Boolean
    }
  }
}
</script>